module.exports = __webpack_public_path__ + "img/home.e603588b.png";